<account-credit-card-list [storeId]="storeId" [confirmCvc]="true" (onCardSelected)="onCreditCardSelected($event)"></account-credit-card-list>

<div padding style="margin-left: 10px;">
  <ion-button type="button" (click)="addCardClicked()" color="primary" class="Textresized" style="height: 20px;">
      {{ 'CreditCard.AddCard' | translate }}
  </ion-button>
</div>